import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const ManageRevenueSplitWrapper = styled.div`
  .manage-revenue-split-modal-box {
    padding: 0 16px;

    .MuiGrid2-root {
      margin: 10px 0;
    }
  }

  .revenue-split-deliverables-section {
    margin: 16px 20px;
  }

  .separator-space {
    margin: 16px 0px;
    border-top: 1px dashed ${COLORS.primary_light_blue4};
  }

  .counseling-cell {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .inline-edit-modal-content {
    padding: 16px 0;
  }
  .manage-revenue-split-modal-box-footer {
    display: flex;
    gap: 8px;
    padding: 0px 16px 20px 16px;
  }
`;
